import { Notice } from "@bokio/designsystem/components/Notice/Notice";
import { Link } from "@bokio/elements/Link/Link";
import BankLangFactory from "@bokio/lang/BankLangFactory";
import { useCompanyInfo } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";
import { getRoute } from "@bokio/shared/route";

import type { BBASveaAuthenticationGateState } from "@bokio/bank/src/bba/useBBASveaAuthenticationGate";
import type { RestrictedAccessState } from "@bokio/hooks/useSignAndPay/useSignAndPay";
import type { FC } from "react";

import * as styles from "./signAndPayGateNotice.scss";

interface SignAndPayGateNoticeProps {
	gateType: BBASveaAuthenticationGateState["type"];
	restrictedAccessState: RestrictedAccessState;
}

export const SignAndPayGateNotice: FC<SignAndPayGateNoticeProps> = ({ gateType, restrictedAccessState }) => {
	const bankLang = BankLangFactory();
	const { companyInfo } = useCompanyInfo();

	if (gateType === "notPermitted" || restrictedAccessState === "noAccess") {
		return (
			<div className={styles.container}>
				<Notice
					color="tips"
					collapsible={false}
					dismissible
					title={bankLang.SignAndPayModal_NoPermissionToSignNotice_Title}
				>
					{bankLang.SignAndPayModal_NoPermissionToSignNotice_Tips}
					<Link route={getRoute("sveaDelegatesManagement", { company: companyInfo.Id })}>
						{bankLang.SignAndPayModal_DelegatedBankAccessLink}
					</Link>
				</Notice>
			</div>
		);
	}

	if (restrictedAccessState === "partialAccess") {
		return (
			<div className={styles.container}>
				<Notice color="info" collapsible={false} dismissible title={bankLang.SignAndPayModal_PartialAccessNotice_Title}>
					{bankLang.SignAndPayModal_PartialAccessNotice_Body}
					<Link route={getRoute("sveaDelegatesManagement", { company: companyInfo.Id })}>
						{bankLang.SignAndPayModal_DelegatedBankAccessLink}
					</Link>
					.
				</Notice>
			</div>
		);
	}

	return null;
};
